import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

export const setAddApiKey = createAsyncThunk("addApiKey/setApiKey", async (inputData) => inputData);

export const initialState = {
    api_key_id: "",
    operation_full_name: "",
    key: "",
    operation_uid: "",
    expiry_date: "",
    status: "active"
};

const addApiKeySlice = createSlice({
    name: "addApiKey",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(setAddApiKey.fulfilled, (state, action) => action.payload);
    }
});

export const selectAddApiKey = ({addApiKey}) => addApiKey;
export default addApiKeySlice.reducer;
